export const SET_CONNECTED = 'setConnected'
export const SET_CONNECT_FAIL = 'setConnectFail'
export const RETRY = 'retry'
export const IS_CONNECTED = 'isConnected'
export const SET_USER_INFO = 'setUserInfo'
export const SET_LIST_ROOM = 'setListRoom'
export const SWITCH_THREAD = 'switchThread'
export const RECEIVE_MESSAGE = 'receiveMessage'
export const RECEIVE_HISTORY_MESSAGE = 'receiveHistoryMessage'
export const USER_ONLINE = 'userOnline'
export const SET_USER_ID = 'setUserId'
export const READ_MESSAGE = 'readMessage'
export const INCOMMING_MESSAGE = 'incommingMessage'
export const SET_OPEN_CHAT = 'setOpenChat'
export const SET_LOADING_ROOM_DATA = 'setLoadingRoomData'
export const SET_IS_LOADING_MESSAGE = 'setIsLoadingMessage'
export const SET_CURRENT_LANG = 'setLanguage'
export const SET_THREAD_SWITCH = 'threadSwitch'
export const SET_UNREAD_THREAD = 'setUnreadThread'
export const ADD_WAIT_MESSAGE = 'addWaitMessage'
export const SET_DRAG_MESSAGE = 'setDragMessage'
export const SET_LOAD_INIT_DATA = 'setLoadInitData'
export const SET_LOADED_INIT_DATA = 'setLoadedInitData'
export const SET_STATUS_APP = 'setStatusApp'
export const FREE_WAIT_MESSAGES = 'freeWaitMessages'
